import { render } from "./InsertMarkdown.vue?vue&type=template&id=147e15c6"
import script from "./InsertMarkdown.vue?vue&type=script&lang=js"
export * from "./InsertMarkdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__